// eslint-disable-next-line @glovo/custom-rules/enforce-glovo-rum
import type { RumEvent } from '@datadog/browser-rum-slim'

export function removeSensitiveData(log: RumEvent) {
  function sensitiveDataReplacer(key: string, value: string | Error): unknown {
    const sensitiveKeys = ['password', 'token', 'auth', 'secret', 'email', 'username']

    const hasSensitiveData = sensitiveKeys.some((sensitiveKey) =>
      key.toLowerCase().includes(sensitiveKey)
    )

    if (hasSensitiveData) {
      return '__REMOVED__'
    }

    // In some URLs we have a token on the url hash,
    // which should not be tracked for security reasons.
    if (key === 'url' && typeof value === 'string') {
      return value.replace(/#.+/, '__REMOVED__')
    }

    if (value instanceof Error) {
      const plainErrorObject: Record<string, unknown> = {}
      Object.getOwnPropertyNames(value).forEach((prop) => {
        plainErrorObject[prop] = (value as Error)[prop as keyof Error]
      })
      return plainErrorObject
    }

    return value
  }

  return JSON.parse(
    JSON.stringify(log, (key, value) =>
      typeof value === 'bigint'
        ? sensitiveDataReplacer(key, value.toString())
        : sensitiveDataReplacer(key, value)
    )
  )
}
